function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M7.7 15.71L4.59 21l-3.18-5.29H7.7z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 8.41l-4.3 7.3H1.41L8.82 3 12 8.41z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M15.18 3L12 8.41 8.82 3h6.36z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.59 15.63s-.02.03-.06.08H16.3L12 8.41 15.18 3s7.36 12.63 7.41 12.63z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M22.53 15.71c-.42.66-3.12 5.29-3.12 5.29l-3.11-5.29h6.23z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.41 21H4.59l3.11-5.29h8.6L19.41 21z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M16.3 15.71H7.7l4.3-7.3 4.3 7.3z"
})));